import http from 'plugins/axios'

export default {
   //顶级合伙人查询
   getTopChannelList({topChannelUserId}){
    return http.get({
      url:`/la/admin/channel/common/topChannelList?topChannelUserId=${topChannelUserId}`
    })
  },
  //获取顶级合伙人列表
  getTopPartner({ page, size, channelUserId, phone, email }) {
    return http.get({
      url: `/la/admin/channel/getChannelList?page=${page}&size=${size}&channelUserId=${channelUserId}&phone=${phone}&email=${email}`,
    });
  },
  //更新后的查询所有用户信息
  getUserList({
    page,
    size,
    startTime,
    endTime,
    symbolId,
    userId,
    channelId,
    channelUserId,
    orderId,
  }) {
    return http.get({
      url: `/channel/order/list?page=${page}&size=${size}&symbolId=${symbolId}&startTime=${startTime}&endTime=${endTime}&userId=${userId}&orderId=${orderId}&channelUserId=${channelUserId}&channelId=${channelId}`,
    })
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/channel/common/symbolList',
    })
  },

  //获取币种列表
  getCoinList() {
    return http.get({
      url: '/channel/common/coinList',
    })
  },
  getHistory(params) {
    return http.get({
      url: '/channel/position/listLog',
      params,
    })
  },
}
